const AppName = "Salish Kids Zone";
const Language = "Salish";
const Tribe = "Salish";
const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_SALISH,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_SALISH,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_SALISH,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_SALISH,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_SALISH,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_SALISH,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_SALISH,
};
const FilePath = "https://storage.googleapis.com/salishmedia/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
// KidsZone data is public/non-sensitive, so this is a plain identifier, not a
// secret -- no env var, no per-community key to provision or rotate. It's
// the immutable database id (not the slug, which is user-editable in
// NACA-Core's community settings and would silently break this if renamed).
const NacaCommunityId = "e415dedd-5fe2-408d-a3f8-95f2e2ca8621";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
  { collection: "KZ_HistoryData", nameToSave: "historyData" },
  { collection: "KZ_StorybookSentence", nameToSave: "storybookSentence" },
  { collection: "KZ_StorybookVocab", nameToSave: "storybookVocab" },
];
const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  // { data: "displayGameType", param: "game-type"},
];

const NumberDataCategory = "Math";

const BottomColor = "rgba(0, 124, 20, 1.0)";

const VersionNumber = "2.03.00003";

const Credits = {
  credits: [
    "Design Concept by Chaney Bell",
    "Translated by Pat Pierre",
    "Language Edited By Melanie Sandoval, Echo Brown, and Johnny Arlee.",
    "The Storybook Corner and Pre-K Kids Zone were funded through MILP funds by the Séliš u Ql̓ispé Culture Committee",
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.nkwusm.com",
      image: "nkwusmLogoFull.png",
      style: "short",
    },
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
    {
      // link: "https://www.nativeteachingaids.com",
      image: "SCC_New_Logo_sm.png",
      style: "tall",
    },
  ],
};

const ShowStorybookCorner = true;

const ShowLinkButton = true;
const Link = "https://preschool-html.web.app/";

const PossibleGames = [
  "Bubble Pop",
  "Counting",
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Verb Activity",
  "Wordless",
  "Item Fall",
  "Solve It",
  "Crocodile",
  "Fill In The Blank",
  "Story Book",
];

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  ShowStorybookCorner,
  ShowLinkButton,
  Link,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  ShowStorybookCorner,
  ShowLinkButton,
  Link,
  PossibleGames,
};
